/** Local studio preferences (alerts, workspace) until server-backed prefs exist. */

export const STUDIO_PREFS_KEY = "taistu_studio_prefs";
export const STUDIO_PREFS_EVENT = "taistu-studio-prefs";

export const DEFAULT_ALERT_PREFS = {
  invoice_reminders: true,
  scope_responses: true,
  packet_sends: false,
  outreach_stale: true,
  blu_finalize: false,
};

export const DEFAULT_WORKSPACE_PREFS = {
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York",
  dateFormat: "MMM d, yyyy",
  neo: "signal",
};

function readRaw() {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(STUDIO_PREFS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function readStudioPrefs() {
  const raw = readRaw();
  return {
    alerts: { ...DEFAULT_ALERT_PREFS, ...(raw.alerts || {}) },
    workspace: { ...DEFAULT_WORKSPACE_PREFS, ...(raw.workspace || {}) },
  };
}

export function writeStudioPrefs(next) {
  if (typeof window === "undefined") return;
  const current = readStudioPrefs();
  const merged = {
    alerts: { ...current.alerts, ...(next.alerts || {}) },
    workspace: { ...current.workspace, ...(next.workspace || {}) },
  };
  localStorage.setItem(STUDIO_PREFS_KEY, JSON.stringify(merged));
  window.dispatchEvent(new Event(STUDIO_PREFS_EVENT));
  return merged;
}

export function readNeoPreference() {
  const neo = readStudioPrefs().workspace?.neo;
  return ["merge", "bloom", "signal"].includes(neo) ? neo : "signal";
}
